import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const VALUES = [
  { label: "Excellence", desc: "Standards académiques exigeants, alignés sur l'ECL France." },
  { label: "Leadership", desc: "Former des décideurs lucides et engagés." },
  { label: "Innovation", desc: "Pédagogie par projets, réels et disruptifs." },
  { label: "Ouverture sur le monde", desc: "Réseau international, mobilité, multiculturalité." },
  { label: "Élégance à la française", desc: "Une signature, une exigence, une posture." },
];

const ABOUT_IMG = "/assets/etudiants-campus-1.jpg";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="section-padding bg-white overflow-hidden">
      <div className="container-edge">
        <div className="grid grid-cols-12 gap-8 lg:gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="col-span-12 lg:col-span-7 zoom-frame"
          >
            <img
              src={ABOUT_IMG}
              alt="Étudiantes en discussion sur le campus"
              className="w-full h-[300px] sm:h-[460px] md:h-[620px] object-cover"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="col-span-12 lg:col-span-5 lg:-ml-16 lg:-mt-8 relative z-10 bg-white p-6 sm:p-8 md:p-10 border border-navy-100"
          >
            <div className="overline mb-5">L'École</div>
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-navy-700 leading-tight mb-6">
              L'audace ivoirienne,<br /> l'<span className="italic text-navy-500">excellence</span> française.
            </h2>
            <p className="text-base md:text-[17px] leading-[1.7] text-[#444]">
              ECL Campus Abidjan, c'est le cœur et l'exigence de l'École de Commerce de Lyon désormais en Côte d'Ivoire. Pas de distance, pas de différence : mêmes diplômes, mêmes chances, mêmes ambitions. Notre conviction : les leaders ne s'adaptent pas au monde… ils le réinventent.
            </p>

            <div className="mt-6">
              <Link to="/formations" className="btn-red inline-flex items-center gap-2">
                Nos formations
                <ArrowRight className="h-4 w-4" />
              </Link>
            </div>

            <div className="red-rule mt-8 mb-6" />

            <ul className="space-y-3" data-testid="about-values-list">
              {VALUES.map((v, i) => (
                <motion.li
                  key={v.label}
                  initial={{ opacity: 0, x: 10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.05 * i }}
                  className="flex items-start gap-3"
                >
                  <CheckCircle2 className="h-5 w-5 text-navy-500 shrink-0 mt-0.5" />
                  <div>
                    <span className="text-navy-700 font-semibold">{v.label}.</span>{" "}
                    <span className="text-[#555] text-sm">{v.desc}</span>
                  </div>
                </motion.li>
              ))}
            </ul>

            <div className="mt-8">
              <Link to="/pourquoi-nous" className="btn-outline-navy inline-flex items-center gap-2">
                Pourquoi nous choisir
                <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
